//excel upload modal (image)
/* eslint-disable react/button-has-type */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./BulkExcelUploadModal.module.scss";
import clsx from "clsx";
import { commonVaribles } from "src/constants/constVariables";
import { Loader } from "src/components/Loader";
import CloudUploadIcon from "src/assets/images/icons/CloudUploadIcon.svg";
import FileIcon from "src/assets/images/icons/FileIcon.svg";
import FileCrossIcon from "src/assets/images/icons/FileCross.svg";
import Select from "react-select";
import { store } from 'src/redux';
import { useSelector } from "react-redux";
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import { packaging_strategy_all_endpoints } from "src/constants/url";
import { baseApiCall } from "src/api/Api";
import { Link } from "react-router-dom";
import { onResponse } from "src/redux/features";
import { useDispatch } from "react-redux";
import useAuthorizationContext from "src/providers/AuthorizationHandler/useAuthorizationContext";

export const BulkExcelUploadModal = ({
  open,
  title,
  handleClose,
  confirmUpload,
  openUploadFile,
  errorMsg,
  handleDrop,
  excelfiles,
  Modalloader,
  handleDragLeave,
  handleDragEnter,
  handleDragOver,
  isPlantName,
  setSetectedPlantName,
  setexcelfile,
  setErrorMessage,
  errorMessage,
  failedFiles,
  directMaterialPurchaseBuyerList,
  commodityTypeList,
  SetSelectedCommodityData,
  isReupload
}) => {
  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState(
		{
      selected_plant: {},
      selected_dmp_user_details: null,
      selected_commodity_type_details: null
    }
	);

  //func for displaying the file name
  const removeExcelFile = (fileName) => {
    const updatedFiles = excelfiles.filter((file) => file.name !== fileName);
    setexcelfile(updatedFiles);
    if (excelfiles.length > 5) {
      setErrorMessage(commonVaribles.excelErrorInNumbers);
    } else {
      if (errorMessage !== commonVaribles.excelErrorInNumbers) {
        setErrorMessage(errorMessage);
        const validExcelFiles = updatedFiles.filter((excel) =>
          /\.(xlsx|xlsm)$/i.test(excel.name)
        );
        const invalidExcelFiles = updatedFiles.filter(
          (excel) => !validExcelFiles.includes(excel)
        );
        if (invalidExcelFiles.length > 0) {
          setErrorMessage(commonVaribles.excelErrormsg);
        } else {
          setErrorMessage("");
        }
      } else {
        setErrorMessage("");
      }
    }
  };

  const plantDataList = useSelector((state) => state.allPlants.plants);
  const fetchPackagingTemplate = () => {
    const requestBody = {
      file_name: commonVaribles.sample_excel_template_name,
      img_type: commonVaribles.sample_excel_template_folder,
    };
    baseApiCall({
      url: packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
      requestBody: requestBody,
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res?.data?.result) {
          fetch(res.data.result)
            .then((response) => response.blob())
            .then((myBlob) => {
              const url = window.URL.createObjectURL(myBlob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", requestBody.file_name + ".xlsx");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        } else {
          failuarBlock();
        }
      },
      onFailure: () => {
        failuarBlock();
      },
      errorCall: () => {
        failuarBlock();
      },
    });
  };

  const failuarBlock = () => {
    dispatch(
      onResponse({
        isToaster: true,
        severity: commonVaribles.error,
        message: commonVaribles.file_download_failed,
      })
    );
  };

  const exportToExcel = (data) => {
    var currentDate = new Date();
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `Failed_Excel_Files_${currentDate.getDate()}_${currentDate.getHours()}_${currentDate.getMinutes()}.xlsx`);
    handleClose();
  };

  const handleAssigneeValue = async (value, name) => {
    switch (name) {
			case 'selected_plant':
        setSetectedPlantName(value);
        setSelectedOption((prev) => ({
          ...prev,
          selected_dmp_user_details: null,
          selected_commodity_type_details: null
        }));
				break;
      case 'selected_commodity_type_details':
        SetSelectedCommodityData(value);
        setSelectedOption((prev) => ({
          ...prev,
          selected_dmp_user_details: null
        }));
				break;
			case 'selected_dmp_user_details':
				break;
			default:
				break;
		}

    setSelectedOption((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const customStyle = {
		control: (provided, state) => ({
			...provided,
			minHeight: '2rem',
		}),
		indicatorSeparator: (state) => ({
			display: 'none',
		}),
		singleValue: (provided) => ({
			...provided,
			color: 'none',
		}),
	};

  //make sure to add those common variables text in the commonvariable.js file. all the common variables are marked with "//" which needs adding.
  return (
    <Modal open={open} onClose={handleClose} className={styles.modalstyle}>
      <div className={styles.containerstyle}>
        <div className={styles["title-div"]}>
          <h1 className={styles.titleStyle}>{title}</h1>
          <div className={styles.closeIconStyle}>
            <CloseIcon onClick={handleClose} />
          </div>
        </div>
        {Modalloader && (
          <div className={styles["loader-div"]}>
            <Loader />
          </div>
        )}
        <div style={{ width: "100%", height: 1, backgroundColor: "#6F6F6F" }} />
        <div className={styles.plantsDropdown}>
          {isPlantName && (
            <span className={styles.plantDropdown}>
              <Select
                defaultValue={store.getState().allPlants?.plantName.length !== 0 ? store.getState().allPlants?.plantName : store.getState().allPlants?.plants[0] }
                styles={customStyle}
                options={plantDataList}
                onChange={(e) => handleAssigneeValue(e, 'selected_plant')}
                isDisabled={isReupload}
              />
            </span>
          )}

          <span className={styles.plantDropdown}>
            <Select
              options={commodityTypeList}
              styles={customStyle}
              value={selectedOption.selected_commodity_type_details}
              onChange={(e) => handleAssigneeValue(e, 'selected_commodity_type_details')}
              placeholder={'Select Commodity*'}
              isDisabled={isReupload}
            />
          </span>

          <span className={styles.plantDropdown}>
            <Select
              options={directMaterialPurchaseBuyerList}
              styles={customStyle}
              value={selectedOption.selected_dmp_user_details}
              onChange={(e) => handleAssigneeValue(e, 'selected_dmp_user_details')}
              placeholder={'Select DMP Buyer*'}
              isDisabled={!selectedOption.selected_commodity_type_details || isReupload}
            />
          </span>
        </div>

        {failedFiles.length > 0 && (
          <div className={styles.downloadFailedDiv}>
            <a
              className={styles.downloadFailedLink}
              onClick={() => exportToExcel(failedFiles)}
            >
              <DownloadIcon />
              <span className={styles.failTitle}>Failed Records</span>
            </a>
          </div>
        )}
        <div className={styles.mainbody}>
          <div className={styles["error-msg"]}>
            {errorMsg && <div className={styles["note"]}>{errorMsg}</div>}
          </div>
          <div
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            draggable={true}
          >
            <Box
              bgcolor="#dadada3d"
              marginTop="13px"
              height={"13rem"}
              width="100%"
              sx={{
                overflowY: "auto",
                display: excelfiles?.length > 0 ? "" : "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className={excelfiles?.length > 2 ? clsx(styles.warningTextGrid) :clsx(styles.warningText)}>
                {excelfiles?.length > 0 &&
                  excelfiles.map((value) => {
                    return (
                      <div className={styles["file-name-container"]}>
                        <img
                          className={styles["file-icon"]}
                          src={FileIcon}
                          alt="File-Icon"
                        />
                        <div className={styles["file-details"]}>
                          <div className={styles["file-name"]}>
                            {value?.name ? value.name : '-'}
                          </div>
                          <div className={styles["file-size"]}>
                            {value?.size ? value.size : '-'} Kb
                          </div>
                        </div>
                        <img
                          className={styles["file-cross-icon"]}
                          src={FileCrossIcon}
                          alt="File-Cross-Icon"
                          onClick={() => {
                            removeExcelFile(value.name);
                          }}
                        />
                      </div>
                    );
                  })}
                {!Modalloader && excelfiles?.length === 0 && (
                  <div
                    onClick={openUploadFile}
                    className={styles["warning-Text"]}
                  >
                    <img
                      className={styles["upload-icon"]}
                      src={CloudUploadIcon}
                      alt="CloudUpload-Icon"
                    />
                    <span className={styles["upload-text"]}>
                      {commonVaribles.strategy_excel_upload_title}
                    </span>
                  </div>
                )}
              </div>
            </Box>
          </div>
          <Link
            onClick={() => fetchPackagingTemplate()}
            underline="hover"
            className={styles.link}
            fontSize={"0.8rem"}
          >
            {commonVaribles.sample_excel_template_label}
          </Link>
          <div className={styles["model-footer"]}>
            <div className={clsx(styles.noteMsgDiv)}>
              <span className={styles["note"]}>{commonVaribles.note}</span>
              <span className={styles["note"]}>
                {commonVaribles.excel_Note}
              </span>
              <span className={styles["note"]}>
                {commonVaribles.excelErrorInNumbers}
              </span>
              <span className={styles["note"]}>
                {commonVaribles.workbook_Note}
              </span>
              <span className={styles["note"]}>
                {commonVaribles.excelFilesSizeError}
              </span>
            </div>
            <div className={styles.bottomRow}>
              <button
                className={clsx(styles.cancelBt, "regularFont")}
                onClick={handleClose}
              >
                {commonVaribles.cancel}
              </button>
              <span>
                <button
                  onClick={() => {
                    confirmUpload(selectedOption);
                  }}
                  className={clsx(styles.uploadBt, "regularFont")}
                  disabled={!(!!(excelfiles?.length) && !!(selectedOption?.selected_dmp_user_details?.value))}
                >
                  {commonVaribles.upload}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

//few props are commented out since they would be required for uploading mutliple excel files and not only a single file.
BulkExcelUploadModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  confirmUpload: PropTypes.func.isRequired,
  openUploadFile: PropTypes.func.isRequired,
  //imageData: PropTypes.array.isRequired,
  //handleRemoveImg: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
  addmore: PropTypes.func.isRequired,
  //removeAll: PropTypes.func.isRequired,
  //handleDrop: PropTypes.func.isRequired,
  //onDragOver: PropTypes.func.isRequired,
};
